/*
 * "For you" tab: the two blocks the design needs but Rivo does not draw.
 * Design: Figma "NOM (all)" 7784-79675.
 *
 * Everything that is only a matter of styling lives in
 * assets/rivo-account-profile.css. This file exists for the two places where
 * markup is genuinely missing:
 *
 *   1. "About Referrals" — Rivo puts the link to its referral page behind a
 *      small arrow glued to the block heading. The design wants it as a text
 *      link beside the copy button, so a second link is created there and the
 *      arrow is hidden by CSS.
 *   2. The tier scale under the progress bar — Rivo renders the bar and the
 *      "unlock" caption, but never the row of tier names and thresholds. It is
 *      built here from window.Rivo.loy_config.vip_tiers, so it always matches
 *      whatever the tiers are in the app rather than the placeholder names in
 *      the design file.
 */
(function () {
  var HOME = '#rivo-tabpanel-rivo';
  var MARKER = 'data-nom-foryou';

  /* Our own referral page, handed over by layout/theme.liquid. Blank while the
     page does not exist in the admin yet. */
  var PAGE_URL = (document.currentScript && document.currentScript.getAttribute('data-referral-url')) || '';

  /* Shopify store credit of the signed-in customer, already formatted
     ("€15", "€0" without credit). Blank for guests only. */
  var STORE_CREDIT = (document.currentScript && document.currentScript.getAttribute('data-store-credit')) || '';

  /* ---------- About Referrals ---------- */

  function referral() {
    var block = document.querySelector(HOME + ' .rivo-aw-home-referral');
    if (!block || block.querySelector('[' + MARKER + '="about"]')) return;

    var source = block.querySelector('.rivo-aw-title-link');
    var container = block.querySelector('.rivo-aw-home-referral-container');
    if (!source || !container) return;

    var about = document.createElement('a');
    about.className = 'nom-referral-about';
    about.setAttribute(MARKER, 'about');
    about.textContent = 'About Referrals';

    var href = PAGE_URL || source.getAttribute('href');
    if (href) {
      about.setAttribute('href', href);
    } else {
      /* Rivo drives the heading with a click handler rather than an href, so
         the new link forwards to it instead of guessing a URL. */
      about.setAttribute('role', 'button');
      about.setAttribute('tabindex', '0');
      about.addEventListener('click', function (event) {
        event.preventDefault();
        source.click();
      });
    }

    container.appendChild(about);
  }

  /* ---------- Tier scale ---------- */

  /*
   * "1st order" / "2nd order" / "10th order", and "Sign up" for the tier
   * everyone is on from the moment they join (threshold 0) — the ladder the
   * design spells out under each name.
   */
  function ordinal(n) {
    var rest = n % 100;
    if (rest >= 11 && rest <= 13) return n + 'th';
    switch (n % 10) {
      case 1: return n + 'st';
      case 2: return n + 'nd';
      case 3: return n + 'rd';
      default: return n + 'th';
    }
  }

  function thresholdLabel(threshold) {
    var from = threshold || 0;
    return from === 0 ? 'Sign up' : ordinal(from) + ' order';
  }

  /*
   * The tier the customer is on, as the app knows it. Rivo reports it by name
   * in the progress heading, so it is matched back against the configured
   * tiers: two of this store's tiers share a prefix ("Nommie", "Nommie+"), and
   * the match is the longest name the heading starts with — a plain prefix
   * test would light up both columns as soon as the customer reaches Nommie+.
   * Matching on the name rather than on a count also keeps this correct when
   * the tiers are renamed in the app.
   */
  function currentTier() {
    var block = document.querySelector(HOME + ' .rivo-aw-home-vip-tier-progress');
    var config = window.Rivo && window.Rivo.loy_config;
    var list = config && config.vip_tiers;
    if (!block || !list || !list.length) return null;

    var heading = block.querySelector('.rivo-aw-vip-tier-progress-heading');
    var name = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!name) return null;

    var found = null;
    list.forEach(function (tier) {
      if (name.indexOf(tier.name) !== 0) return;
      if (!found || tier.name.length > found.name.length) found = tier;
    });

    return found;
  }

  function tiers() {
    var block = document.querySelector(HOME + ' .rivo-aw-home-vip-tier-progress');
    if (!block || block.querySelector('[' + MARKER + '="scale"]')) return;

    var wrapper = block.querySelector('.rivo-aw-vip-tier-progress-bar-wrapper');
    var config = window.Rivo && window.Rivo.loy_config;
    var list = config && config.vip_tiers;
    if (!wrapper || !list || !list.length) return;

    var current = currentTier();

    var sorted = list.slice().sort(function (a, b) {
      return (a.threshold || 0) - (b.threshold || 0);
    });

    var scale = document.createElement('div');
    scale.className = 'nom-tier-scale';
    scale.setAttribute(MARKER, 'scale');

    /*
     * One column per tier — name over threshold — rather than two rows of
     * cells. The design (Figma "NOM (all)" 8309-81349) spreads those columns
     * with `space-between` and lets each keep its own width, which is what
     * makes the gaps between them read as equal; two rows of equal-width cells
     * cannot do that, because the words inside them are not equally wide.
     */
    sorted.forEach(function (tier) {
      var isCurrent = tier === current;

      var item = document.createElement('div');
      item.className = 'nom-tier-scale__item' + (isCurrent ? ' is-current' : '');

      var name = document.createElement('span');
      name.className = 'nom-tier-scale__name';
      name.textContent = tier.name;

      var amount = document.createElement('span');
      amount.className = 'nom-tier-scale__amount';
      amount.textContent = thresholdLabel(tier.threshold);

      item.appendChild(name);
      item.appendChild(amount);
      scale.appendChild(item);
    });

    wrapper.appendChild(scale);
  }

  /* ---------- Star position ---------- */

  /*
   * Rivo's bar has two points on it, not five: its fill is
   * `percentage_to_next_tier` — how far the customer is from this tier to the
   * next one — and it knows nothing about the ladder drawn underneath. Left
   * alone it puts the star halfway along the track for someone halfway to
   * their second tier, which lands under the THIRD column and reads as "you
   * are on Nommie+" when they are on Nommie.
   *
   * Here the ladder is the scale, so the fill ends at the centre of the
   * current tier's column instead, the way
   * snippets/collection-tier-progress.liquid already places the dot and the
   * star on the gated collection bar. The star needs nothing of its own: it is
   * glued to the end of the fill (see rivo-account-profile.css).
   *
   * The centre is measured rather than computed. On the collection bar the
   * columns are equal-width, so a formula gives their centres; these keep
   * their own widths (`space-between`, so the words set the gaps), which puts
   * the centres at no even fraction of the track.
   */
  function pin() {
    var block = document.querySelector(HOME + ' .rivo-aw-home-vip-tier-progress');
    if (!block) return;

    var track = block.querySelector('.rivo-aw-vip-tier-progress-track');
    var current = block.querySelector('.nom-tier-scale__item.is-current');

    /* No ladder, or a tier name Rivo and the config disagree on: leave Rivo's
       own width alone rather than pin the star somewhere invented. */
    if (!track || !current) {
      block.classList.remove('nom-tier-pinned');
      return;
    }

    var trackBox = track.getBoundingClientRect();
    /* Slideout still closed — nothing to measure. The observers come back. */
    if (!trackBox.width) return;

    var box = current.getBoundingClientRect();
    var centre = box.left + box.width / 2 - trackBox.left;
    var percent = Math.min(Math.max((centre / trackBox.width) * 100, 0), 100);

    block.style.setProperty('--nom-tier-progress', percent.toFixed(2) + '%');
    block.classList.add('nom-tier-pinned');
  }

  /* ---------- Hero subtitle ---------- */

  /*
   * Rivo prints the points balance under the greeting ("You have 0 points"),
   * which is wrong here on both halves: this store runs on credit, not points
   * (`points_program_enabled` is off, `credit_mode` is on), and the design
   * puts the customer's tier there instead — "Check out your <tier> bonuses:".
   *
   * The tier name is taken from the app rather than written out, so renaming a
   * tier in Rivo renames it here too. Rivo owns .rivo-aw-subtitle and rewrites
   * it whenever it re-renders the home tab, so ours is a separate node beside
   * it and the original is hidden by CSS only once ours is in place — until
   * the tier is known, Rivo's own line stays rather than an empty gap.
   */
  function subtitle() {
    var heading = document.querySelector(HOME + ' .rivo-aw-home-hero .rivo-aw-heading');
    if (!heading) return;

    var tier = currentTier();
    var own = heading.querySelector('[' + MARKER + '="subtitle"]');

    if (!tier) {
      if (own) own.remove();
      heading.classList.remove('nom-has-subtitle');
      return;
    }

    var text = 'Check out your ' + tier.name + ' bonuses:';

    if (!own) {
      own = document.createElement('div');
      own.className = 'nom-hero-subtitle';
      own.setAttribute(MARKER, 'subtitle');
      heading.appendChild(own);
    }

    /* Writing only on a real change keeps the observer from looping. */
    if (own.textContent !== text) own.textContent = text;
    heading.classList.add('nom-has-subtitle');
  }

  /* ---------- Store credit ---------- */

  /*
   * "Your store credit: €15" right under the greeting. The amount is Shopify's
   * own balance, handed over by layout/theme.liquid: Rivo's balance does not
   * see credit issued outside the app, so it would show €0 to most members.
   * The line sits in Rivo's heading like the tier subtitle, and is put back
   * after the title whenever Rivo rebuilds the heading.
   */
  function credit() {
    var heading = document.querySelector(HOME + ' .rivo-aw-home-hero .rivo-aw-heading');
    if (!heading) return;

    var own = heading.querySelector('[' + MARKER + '="credit"]');
    if (!STORE_CREDIT) {
      if (own) own.remove();
      return;
    }

    var text = 'Your store credit: ' + STORE_CREDIT;
    if (!own) {
      own = document.createElement('div');
      own.className = 'nom-hero-credit';
      own.setAttribute(MARKER, 'credit');
    }
    if (own.textContent !== text) own.textContent = text;

    /* Moving only when out of place keeps the observer from looping. */
    var title = heading.querySelector('.rivo-aw-title') || heading.firstElementChild;
    if (title && title.nextElementSibling !== own) title.insertAdjacentElement('afterend', own);
  }

  /* ---------- Progress caption ---------- */

  /*
   * Rivo builds the caption from two translation strings — "Earn {{points}}
   * Points" and "to unlock" — which reads wrong here twice over: this store's
   * tiers count orders, not points, and Rivo has no plural forms, so editing
   * those strings in the app would produce "You're 7 order away".
   *
   * The sentence is rewritten instead, taking the number and the tier name
   * from Rivo's own spans rather than parsing its wording. Anything else —
   * the highest-tier message, for instance — is left exactly as Rivo wrote it.
   */
  function caption() {
    var subtitle = document.querySelector(
      HOME + ' .rivo-aw-vip-tier-progress-subtitle'
    );
    if (!subtitle) return;

    var group = subtitle.parentElement;
    if (!group) return;

    var spans = subtitle.querySelectorAll('span');
    var count = spans.length > 1
      ? parseInt(spans[0].textContent.replace(/\D/g, ''), 10)
      : 0;
    var tier = spans.length > 1 ? spans[1].textContent.trim() : '';

    /*
     * On the highest tier Rivo prints a message of its own with no numbers in
     * it. Nothing to restate there, so ours is removed and Rivo's is shown.
     */
    if (!count || !tier) {
      var stale = group.querySelector('[' + MARKER + '="caption"]');
      if (stale) stale.remove();
      group.classList.remove('nom-has-caption');
      return;
    }

    var text = "You're " + count + (count === 1 ? ' order' : ' orders') +
      ' away from ' + tier + '.';

    var own = group.querySelector('[' + MARKER + '="caption"]');
    if (!own) {
      own = document.createElement('div');
      own.className = 'nom-progress-caption';
      own.setAttribute(MARKER, 'caption');
      group.appendChild(own);
    }

    /* Writing only on a real change keeps the observer from looping. */
    if (own.textContent !== text) own.textContent = text;
    group.classList.add('nom-has-caption');
  }

  function apply() {
    referral();
    tiers();
    subtitle();
    credit();
    caption();
    pin();
  }

  function start() {
    apply();

    var content = document.querySelector('.rivo-slideout__content');
    if (!content) return;

    /* Rivo rebuilds the home tab on every navigation. Re-applying on mutation
       cannot loop: each append fires the observer, and the next pass finds the
       marker and returns. `pin()` only ever writes attributes, which this
       observer does not watch, so it cannot loop either. */
    new MutationObserver(apply).observe(content, { childList: true, subtree: true });

    /*
     * The star is pinned to a measured column, so it has to be re-measured
     * whenever the columns can move: the slideout opening (width 0 → real),
     * the window resizing, and the webfont arriving and changing how wide the
     * tier names are.
     */
    if (window.ResizeObserver) {
      new ResizeObserver(pin).observe(content);
    } else {
      window.addEventListener('resize', pin);
    }

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(pin);
  }

  document.addEventListener('rivo-accounts:loaded', start);

  var tries = 0;
  var poll = window.setInterval(function () {
    tries += 1;
    if (document.querySelector('.rivo-slideout__content')) {
      window.clearInterval(poll);
      start();
      return;
    }
    /* ~10s. Past that Rivo is not on this page and there is nothing to wait for. */
    if (tries > 40) window.clearInterval(poll);
  }, 250);
})();
